import { useQuery } from '@tanstack/react-query'
import { fetchVATReportingMethods, IGeneralConstantOption } from '../constants'
import { useBusinessContext } from '@root/context'

export const useVATReportingMethods = () => {
  const { slug } = useBusinessContext()

  return useQuery<IGeneralConstantOption[]>({
    queryKey: [slug, 'vat_reporting_methods'],
    queryFn: () => fetchVATReportingMethods({ slug }),
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnMount: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!slug
  })
}
